import React from 'react';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import type { SearchAllContentOrganizationHit } from '../../types';
import Card from '../../../Card';

// eslint-disable-next-line max-len
const SearchAllContentResultsOrganizationHit: React.FC<{ hit: SearchAllContentOrganizationHit }> = ({ hit }) => {
  const { t } = useTranslation();

  return (
    <Card
      className="SearchAllContent__Results__hit"
      url={hit.url[0]}
      label={t(`content_types.${hit.type[0]}.type`)}
      labelIcon="domain"
      title={<Highlight attribute="title" hit={hit} />}
    />
  );
};

export default SearchAllContentResultsOrganizationHit;
